const sliderData = [
	{
		imgSrc: require('@/assets/slider/1.jpeg'),
		content: {
			caption: 'Dostosujemy ofertę do twojego przedsiębiorstwa',
			subcaption: 'Poznaj naszą ofertę i sprawdź ile możesz zaoszczędzić',
			btnText: 'Sprawdź ofertę',
			btnHref: '/oferta',
			btnClass: [],
		},
		imgAlt: 'Rachunkowość',
	},
	{
		imgSrc: require('@/assets/slider/2.jpeg'),
		content: {
			caption: 'Oferujemy szeroki zakres usług księgowych',
			subcaption: 'Obsłużymy nawet najbardziej wymagających klientów',
			btnText: 'Dowiedz się więcej',
			btnHref: '/oferta',
			btnClass: [],
		},
		imgAlt: 'Ksiegowość',
	},
	// {
	// 	imgSrc: require('@/assets/slider/2.jpeg'),
	// 	content: {
	// 		caption: 'Posiadamy duże doświadczenie i wysokie kwalifikacje',
	// 		subcaption:
	// 			'potwierdzone certyfikatamy Polskiego Stowarzyszenia Księgowych',
	// 		btnText: 'Dowiedz się więcej',
	// 		btnHref: '/o-nas',
	// 		btnClass: [],
	// 	},
	// 	imgAlt: 'Ksiegowość',
	// },
]

export { sliderData }
